import { useState, useEffect } from "react";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useGetInteractions = ({leadID}) => {
    const [lastInteraction, setLastInteraction] = useState(null)
    const [allInteractions, setAllInteractions] = useState(null)

    const fetchData = async() => {
        if (!leadID) return;
        
        try{
            const queryParams = new URLSearchParams({
                lead_id: leadID
            })
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_INTERACTIONS.LAST_INTERACTIONS}?${queryParams}`, 'GET')
            setLastInteraction(result)

            const allResult = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_INTERACTIONS.ALL_INTERACTIONS}?${queryParams}`)
            setAllInteractions(allResult)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        fetchData()
    }, [leadID])
    return {lastInteraction, allInteractions, refetch: fetchData}
}
